import { axios } from '@/utils/request'
import { filterData } from '@/utils/util'
const api = {
  sysOperationLog: '/sysOperationLog/pageList'
}
export function sysOperationLog(params) {
  return axios({
    url: api.sysOperationLog,
    method: 'get',
    params: filterData(params),
    headers: {
      'Content-Type': 'application/json;utf-8'
    },
    func:'查询系统操作日志列表'
  })
}
